import script from "./GridCategoriasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridCategoriasComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridCategoriasComponent.vue?vue&type=style&index=0&id=1844f4c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1844f4c6"]])

export default __exports__